import { gql } from '@/__generated__';
import { AdvancedFilters_GetHardwareOptionsQuery } from '@/__generated__/graphql';

export type HardwareOption = AdvancedFilters_GetHardwareOptionsQuery['hardwareOptions'][number];

export const GET_HARDWARE_OPTIONS = gql(`#graphql
  query AdvancedFilters_GetHardwareOptions {
    hardwareOptions {
      id
      name
      type
    }
  }
`);
